import { render, staticRenderFns } from "./MeasureEditor.vue?vue&type=template&id=532d8894&scoped=true"
import script from "./MeasureEditor.vue?vue&type=script&lang=js"
export * from "./MeasureEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532d8894",
  null
  
)

export default component.exports